import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { Languages } from "lucide-react";

export const SUPPORTED_LANGS = ["es", "en", "fr", "pt", "ro", "ar", "zh", "it", "wo"];

export const FLAGS = {
  es: { label: "Español", flag: "🇪🇸" },
  en: { label: "English", flag: "🇬🇧" },
  fr: { label: "Français", flag: "🇫🇷" },
  ro: { label: "Română", flag: "🇷🇴" },
  ar: { label: "العربية", flag: "🇸🇦" },
  zh: { label: "中文", flag: "🇨🇳" },
  pt: { label: "Português", flag: "🇵🇹" },
  it: { label: "Italiano", flag: "🇮🇹" },
  wo: { label: "Wolof", flag: "🇸🇳" }
};

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const handleLanguageChange = (newLang) => {
    setIsOpen(false);
    const segments = location.pathname.split("/").filter(Boolean);
    if (segments.length > 0 && SUPPORTED_LANGS.includes(segments[0])) {
      segments[0] = newLang;
    } else {
      segments.unshift(newLang);
    }
    const newPath = `/${segments.join("/")}${location.hash}`;
    navigate(newPath);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 bg-[#F5F1EA] hover:bg-[#E8D5A0]/20 rounded-full px-4 py-2 border border-[#E8E4DC] transition-colors"
      >
        <Languages className="w-4 h-4 text-[#C8A24D]" />
        <span className="text-sm font-semibold text-[#0C2340]">
          {FLAGS[i18n.language]?.flag} {i18n.language ? i18n.language.toUpperCase() : "ES"}
        </span>
      </button>
      {isOpen && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setIsOpen(false)}></div>
          <div className="absolute right-0 top-full mt-2 w-48 bg-white border border-[#E8E4DC] rounded-xl shadow-lg z-50 overflow-hidden animate-fade-in pb-1 pt-1 max-h-64 overflow-y-auto">
            {SUPPORTED_LANGS.map(l => (
              <button
                key={l}
                onClick={() => handleLanguageChange(l)}
                className={`w-full text-left px-4 py-2 text-sm font-medium transition-colors hover:bg-[#F5F1EA] ${i18n.language === l ? 'bg-[#F5F1EA] text-[#0C2340]' : 'text-[#4A5568]'}`}
              >
                <span className="mr-2 text-base">{FLAGS[l]?.flag}</span>
                {FLAGS[l]?.label}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};
